// src/components/HowItWorks/HowItWorks.tsx
import React from 'react';
import './HowItWorks.css';

interface Step {
  number: number;
  title: string;
  description: string;
}

const HowItWorks: React.FC = () => {
  const steps: Step[] = [
    {
      number: 1,
      title: 'Book Your Session',
      description: 'Choose your service and schedule a convenient time for your reading.'
    },
    {
      number: 2,
      title: 'Provide Birth Details',
      description: 'Share your birth date, time, and location for accurate chart calculation.'
    },
    {
      number: 3,
      title: 'Receive Your Reading',
      description: 'Join your personalized session via video call or receive your detailed report.'
    }
  ];

  return (
    <section className="how-it-works">
      <div className="container">
        <h2>How It Works</h2>
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={step.number} className="step">
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;